import styles from './index.module.sass'

const NotAvailable = ({ title, description, actionText, onClick }) => (
  <div className={styles.container}>
    <div className={styles.content}>
      <div className={styles.title}>{title}</div>
      <div className={styles.description}>{description}</div>
      <button className={styles.actionButton} onClick={onClick}>
        {actionText}
      </button>
    </div>
  </div>
)

export default NotAvailable
